import { z } from 'zod';

const namespaceSchema = z
  .string()
  .min(1, 'Namespace is required')
  .max(150, 'Namespace must be at most 150 characters')
  .regex(
    /^[a-zA-Z0-9]([a-zA-Z0-9._-]*[a-zA-Z0-9])?$/,
    'Namespace can only contain letters, numbers, dots, hyphens and underscores'
  );

export function validateNamespace(value: string): true | string {
  const result = namespaceSchema.safeParse(value);
  if (result.success) {
    return true;
  }
  const first = result.error.errors[0];
  return first?.message ?? 'Invalid namespace';
}
